import { action, makeObservable, observable } from 'mobx';
import { singleton } from 'tsyringe';

import { ClassifierDto } from '@/application/interfaces/pegasus.gateway';

type classifiersTrackingInfo = {
  level_1: string;
  level_name_1: string;
  level_2?: string;
  level_name_2?: string;
  level_3?: string;
  level_name_3?: string;
};

@singleton()
export class ClassifiersStore {
  @observable classifiers: ClassifierDto[];
  @observable classifierGuidFromCache: string;
  @observable classifiersTrackingInfo: classifiersTrackingInfo;

  constructor() {
    makeObservable(this);
  }

  @action
  findCourseClassifiers = (courseGuid) => {
    const result = {
      level_1: '',
      level_name_1: '',
      level_2: '',
      level_name_2: '',
      level_3: '',
      level_name_3: '',
    };

    const searchClassifiers = (classifiers = [], parentNames = []) => {
      if (!Array.isArray(classifiers)) return;

      classifiers.forEach((classifier) => {
        if (!classifier) return;

        if (classifier.courses) {
          const course = classifier.courses.find((course) => course?.guid === courseGuid);
          if (course) {
            parentNames.forEach((parent) => {
              if (parent?.classificationLevel?.level) {
                result[`level_${parent.classificationLevel.level}`] = parent.guid;
                result[`level_name_${parent.classificationLevel.level}`] = parent.name;
              }
            });

            if (classifier.classificationLevel?.level) {
              result[`level_${classifier.classificationLevel.level}`] = classifier.guid;
              result[`level_name_${classifier.classificationLevel.level}`] = classifier.name;
            }
          }
        }

        if (Array.isArray(classifier.childClassifiers) && classifier.childClassifiers.length > 0) {
          searchClassifiers(classifier.childClassifiers, [...parentNames, classifier]);
        }
      });
    };

    searchClassifiers(this.classifiers, []);

    this.classifiersTrackingInfo = result;
  };

  @action
  setClassifiers = (classifiers: ClassifierDto[]) => {
    this.classifiers = classifiers;
  };

  @action
  setClassifierGuidFromCache = (classifierGuidFromCache: string) => {
    this.classifierGuidFromCache = classifierGuidFromCache;
  };
}
